const menuMain = {
    init() {
        const menuTrigger = '.masthead__menu .has-mega-menu';
        const bodyBind = $('body');
        const megaMenuWrapper = $('.masthead__mega-menu');

        $(document).on('click', function(){
            $('.masthead__mega-menu').removeClass('active');
            $('.has-mega-menu').removeClass('menu-active');
        })

        bodyBind.on('click', menuTrigger, function(e){
            e.stopPropagation();
            e.preventDefault();

            let $this = $(this);
            var $item = $this.attr('id');
            var $megaMenuID = $item.replace('menu-item', 'mega-menu');
            $(menuTrigger).removeClass('menu-active');
            $this.toggleClass('menu-active');
            triggerMenu($megaMenuID, $this);

            $('.mini-cart__menu').hide();

        })


        function triggerMenu($megaMenuID, $this){

            if($('#' + $megaMenuID ).hasClass('active')){
                $this.removeClass('menu-active');
                $('#' + $megaMenuID).removeClass('active');
            }else{
                megaMenuWrapper.removeClass('active');
                $('#' + $megaMenuID).addClass('active');
            }

        }


        $(document).on('click', '.mobile-menu .has-mega-menu', function(){
            var menuID = $(this).attr('class').split(" ").reverse()[0].replace('menu-item', 'mega-menu-mobile');
            console.log('#' + menuID);
            $('#' + menuID).addClass('active');

        });

        $(document).on('click', '.mobile-menu .child li', function(e){

            $(this).parent().find('.grand-child').addClass('active');
        });

        $(document).on('click', '.js-back', function(){
            $(this).parent().removeClass('active');
        })

        $(document).on('click', '.parent.js-back', function(){
            $(this).parent().parent().removeClass('active');
        })



    }

}

export {menuMain}